import { useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { constants } from "@lib/constants";
// import { requestForToken } from "../firebase";

import { fetchProfileDetails } from "@redux/reducer.profile";
import useAxiosLogout from "../hooks/useAxiosLogout";

export const useLayoutEffects = ({ dispatch, axiosGet, userId }) => {
  const sentRef = useRef(false);
  const { logOut } = useAxiosLogout();

  // 🔐 Token validation
  useEffect(() => {
    const token = localStorage.getItem("auth-token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) logOut();
    } catch {
      logOut();
    }
  }, []);

  // 📦 Only fetch profile details at layout mount
  useEffect(() => {
    if (!userId) {
      logOut();
      return;
    }

    dispatch(fetchProfileDetails({ axiosGet, params: userId }));
  }, [userId, dispatch, axiosGet]);

  // 🔔 Push token
  useEffect(() => {
    if (!userId || sentRef.current) return;

    sentRef.current = true;

    (async () => {
      try {
        const { requestForToken } = await import("../firebase");

        const token = await requestForToken();

        if (!token) return;

        await axios.post(`${constants.BASE_URL}push/save-token`, {
          token,
          userId,
        });
      } catch (err) {
        console.error("Push token error:", err);
      }
    })();
  }, [userId, dispatch]);
};
